import { useQuery } from "@tanstack/react-query";
import { StudentStatsResponse } from "../interface";
import { axiosInterceptor } from "..";

const fetchStudentStats = async (
  orgId: string,
  subUserId: string
): Promise<StudentStatsResponse> => {
  const { data } = await axiosInterceptor.get(
    `progression-b2b/${orgId}/${subUserId}/stats`
  );
  return data;
};

const useSingleStudentStats = (orgId?: string, subUserId?: string) => {
  return useQuery({
    queryKey: ["studentStats", orgId, subUserId],
    queryFn: () => {
      if (!orgId || !subUserId)
        return Promise.reject("Missing orgId or subUserId");
      return fetchStudentStats(orgId, subUserId);
    },
    enabled: !!orgId && !!subUserId,
  });
};

export default useSingleStudentStats;
